import React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsComponent from './Components/Settings';

const Settings = () => {
  return (
    <>
      <SettingsComponent />
      {/* This is where sub-routes will be rendered */}
      <Outlet />
    </>
  );
};

export default Settings;
